import styled from 'styled-components';

import Row from '@Components/atoms/Row';

export const StyledRow = styled(Row)`
  margin-top: ${(props) => props.theme.space.large_32};
  margin-bottom: ${(props) => props.theme.space.xl_64};
  min-height: 300px;

  @media (max-width: ${(props) => props.theme.device.mobile}) {
    min-height: 100px;
    margin-top: 0;
    margin-bottom: ${(props) => props.theme.space.xl_64};
  }
`;
